module.exports = __webpack_public_path__ + "static/img/8.6b01b4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/8.png
// module id = CuDP
// module chunks = 0